<template>
<div class="chapter">
<div class="inner_page">
<div id="fm6">
<p class="h1"><span>Acknowledgements</span></p>
<p>My thanks to: Marisa and Jack for their understanding and indulgence; Andrew Torrance and Steve T for their technical insight; and Frightened Rabbit for the soundtrack in my head.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?72886470